import clsx from "clsx";
import { type PropsWithChildren, cloneElement, isValidElement } from "react";

import { useTour } from "@/hooks/useTour";
import { DemoContext } from "@/providers/demo/DemoContext";

type DemoClickWrapperProps = PropsWithChildren<{
  /**
   * Optional: disable the paywall and allow normal click behavior
   * Use this for non-critical actions that should still work in demo
   */
  allowInDemo?: boolean;

  /**
   * Optional: custom className to apply to wrapper
   */
  className?: string;
}>;

export const DemoClickWrapper = ({ children, allowInDemo = false, className }: DemoClickWrapperProps) => {
  const { isDemoMode } = DemoContext.useDemo();
  const { isTourActive } = useTour();

  if (!isDemoMode || allowInDemo) {
    return children;
  }

  // Clone the child element and override its click handlers
  // Only prevent actions if tour is active
  if (isValidElement(children)) {
    return cloneElement(children as any, {
      onPress: (e: any) => {
        if (isTourActive) {
          e?.preventDefault?.();
          e?.stopPropagation?.();
        }
      },
      onClick: (e: any) => {
        if (isTourActive) {
          e?.preventDefault?.();
          e?.stopPropagation?.();
        }
      },
      className: clsx((children as any).props.className, className, { "!cursor-default": isTourActive }),
    });
  }

  return children;
};
